
import React      from 'react';
import CSSModules from 'react-css-modules';
import moment     from 'moment';

import Button           from '../Button';
import FontIcon         from '../FontIcon';
import Overlay          from '../Overlay';
import YesNoOptionPanel from '../YesNoOptionPanel';
import EventForm        from '../EventForm';
import AttendeeForm     from '../AttendeeForm';
import Checkbox         from '../Checkbox';
import InputGroup       from '../InputGroup';
import Label            from '../Label';
import SelectBox        from '../SelectBox';
import SortArrow        from '../SortArrow';
import BooleanIcon      from '../BooleanIcon';
import WebsitePositionDropDown from '../WebsitePositionDropDown';

import authenticator from '../../services/authenticator';
import eventRepo     from '../../services/events';
import notifier from '../../services/notifier';

import * as eventList from '../../actions/eventList';

import attendees from '../../services/attendees';

import { connect } from 'react-redux';

import style from './style.scss';

class EventList extends React.Component {

    componentDidMount() {

        this.props.refreshEvents();
        this.props.refreshEventOptions();
        this.props.refreshWebsiteAvailablePositionsForEvents();
    }

    _getAttendeesDropdownLink(eventId) {

        if (this._isShowingAttendees(eventId)) {

            return (
                <div styleName="show-attendees-container">

                    <a styleName="attendees-link"
                       onClick={ this.props.hideAttendees.bind(this, eventId) }>

                        <FontIcon className={ style['show-attendees-icon'] }
                                  textPosition="right"
                                  iconName="chevron-up" />

                        <span>Hide attendees</span>
                    </a>

                </div>
            );

        } else {

            return (
                <div styleName="show-attendees-container">

                    <a styleName="attendees-link"
                       onClick={ this.props.showAttendees.bind(this, eventId) }>

                        <FontIcon className={ style['show-attendees-icon'] }
                                  textPosition="right"
                                  iconName="chevron-down" />

                        <span>Show attendees</span>
                    </a>

                </div>
            );
        }
    }

    _attendeeSelected(eventId, attendeeId, e) {

        this.props.attendeeSelectionChanged(eventId, attendeeId, e.target.checked);
    }

    _getSelectedAttendeesCount(attendees) {

        return attendees.reduce((carry, attendee) => {

            if (attendee.selected) {

                return carry + 1;

            } else {

                return carry;
            }

        }, 0);
    }

    _getSelectedAttendees(event) {

        return event.attendees.filter((attendee) => {

            return attendee.selected;
        });
    }

    _getSelectedEmailAddressList(event) {

        return this._getSelectedAttendees(event)
            .map((attendee) => {

                return attendee.email;
            });
    }

    _sendJoiningInstructions(event, window) {

        const attendeesToUpdate = this._getSelectedAttendees(event)
            .map((attendee) => {

                return {
                    ...attendee,
                    instructed: true
                };
            });

        attendees.updateMultiple(attendeesToUpdate)
            .then(this.props.attendeesUpdated.bind(this, event.id));

        window.open('https://mail.google.com/a/rhenvironmental.co.uk/?view=cm&bcc=' + this._getSelectedEmailAddressList(event), '_blank')
            .focus();
    }

    _sortAttendees(eventId, attribute) {

        const sortDirection = this.props.attendeeSorts[eventId][attribute];

        if (sortDirection === null) {

            this.props.sortAttendees(eventId, attribute, 'asc');

        } else if (sortDirection === 'asc') {

            this.props.sortAttendees(eventId, attribute, 'desc');

        } else {

            this.props.sortAttendees(eventId, attribute, null);
        }
    }

    _toggleAttendingMultipleDays(attendee) {

        this.props.toggleAttendingMultipleDays(attendee);
    }

    _getAttendeesList(event) {

        if (this._isShowingAttendees(event.id)) {

            return (
                <div>
                    <table styleName="attendees-table">

                        <thead>
                        <tr>
                            <th>
                                <Checkbox value={ event.isSelectingAllAttendees }
                                          checked={ event.isSelectingAllAttendees }
                                          onChange={ this.props.toggleSelectAllAttendees.bind(this, event.id) } />
                            </th>
                            <th>Instructed</th>
                            <th>Attending <br/>All Days</th>
                            <th>
                                <span onClick={ this._sortAttendees.bind(this, event.id, 'last_name') }
                                      styleName="attendees-table__heading--sortable">
                                    Name
                                </span>

                                <SortArrow size="small"
                                           onClick={ this._sortAttendees.bind(this, event.id, 'last_name') }
                                           direction={ this.props.attendeeSorts[event.id]['last_name'] }
                                           styleName="attendees-table__sort-arrow" />
                            </th>
                            <th>
                                <span onClick={ this._sortAttendees.bind(this, event.id, 'organisation') }
                                      styleName="attendees-table__heading--sortable">
                                    Organisation
                                </span>

                                <SortArrow size="small"
                                           onClick={ this._sortAttendees.bind(this, event.id, 'organisation') }
                                           direction={ this.props.attendeeSorts[event.id]['organisation'] }
                                           styleName="attendees-table__sort-arrow" />
                            </th>
                            <th>Job Title</th>
                            <th>Requirements</th>
                            <th>Email</th>
                        </tr>
                        </thead>

                        <tbody>

                        {
                            event.attendees.map((attendee, index) => {

                                return (
                                    <tr key={ index }>
                                        <td>
                                            <Checkbox value={ attendee.selected }
                                                      checked={ attendee.selected }
                                                      onChange={ this._attendeeSelected.bind(this, event.id, attendee.id) } />
                                        </td>
                                        <td>
                                            <BooleanIcon value={ attendee.instructed } />
                                        </td>
                                        <td>
                                            <BooleanIcon showHoverEffect={ true }
                                                         onClick={ this._toggleAttendingMultipleDays.bind(this, attendee) }
                                                         value={ attendee.attending_all_days  } />
                                        </td>
                                        <td className={style[attendee.provisional_booking ? 'provisional-booking' : '']}>{ attendee.first_name } { attendee.last_name }</td>
                                        <td className={style[attendee.provisional_booking ? 'provisional-booking' : '']}>{ attendee.organisation }</td>
                                        <td className={style[attendee.provisional_booking ? 'provisional-booking' : '']}>{ attendee.job_title || '–' }</td>
                                        <td className={style[attendee.provisional_booking ? 'provisional-booking' : '']}>{ attendee.requirements || '–' }</td>
                                        <td>
                                            <a target="_blank" href={ `https://mail.google.com/a/rhenvironmental.co.uk/?view=cm&to=${ attendee.email }` }>
                                                { attendee.email }
                                            </a>
                                        </td>
                                        <td>
                                            <div styleName="attendee-action-panel">

                                                <a onClick={ this.props.showEditAttendeeOverlay.bind(this, attendee) }
                                                   styleName="attendee-action">
                                                    Edit
                                                </a>

                                                <span styleName="action-break">|</span>

                                                <a onClick={ this.props.showDeleteAttendeeOverlay.bind(this, attendee) }
                                                   styleName="attendee-action">
                                                    Delete
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })
                        }

                        </tbody>

                    </table>

                    <div styleName="attendee-button-panel">

                        <Button styleName="attendee-button" onClick={ this.props.showAddAttendeeOverlay.bind(this, event.id) }>
                            Add attendee
                        </Button>

                        <Button styleName="attendee-button" onClick={ this._sendJoiningInstructions.bind(this, event, window) }>
                            <span>Email selected attendees</span>&nbsp;
                            <span>({ this._getSelectedAttendeesCount(event.attendees) })</span>
                        </Button>

                    </div>
                </div>
            );

        }

    }

    _isShowingAttendees(targetEventId) {

        const index = this.props.eventsShowingAttendees.findIndex((eventId) => {

            return targetEventId === eventId;
        });

        return index !== -1;
    }

    _getDeleteEventOverlayContent() {

        if (this.props.isDeleteEventOverlayOpen) {

            const { eventToDelete } = this.props;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete this event along with it's booking details?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteEventOverlay }
                                      yes={ this.props.deleteEvent.bind(this, eventToDelete.id) } />

                </div>
            );
        }
    }

    _getDeleteAttendeeOverlayContent() {

        if (this.props.isDeleteAttendeeOverlayOpen) {

            const { attendeeToDelete } = this.props;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete&nbsp;
                        <span styleName="attendee-to-delete">{ attendeeToDelete.first_name } { attendeeToDelete.last_name }</span>&nbsp;
                        from this event?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeleteAttendeeOverlay }
                                      yes={ this.props.deleteAttendee.bind(this, attendeeToDelete.id) } />

                </div>
            );
        }
    }

    _getEventAddress(event) {

        if (event.venue && event.venue.address) {

            return <span>{ event.venue.address.address_1 }, { event.venue.address.post_code }</span>;
        }

        return <span>&ndash;</span>
    }

    _getEventDates(event) {

        if (event.multiple_days) {
            return event.multiple_days_events.map(multiple_day => {
                return (
                    <span className={style['multi-event-date']}>{ moment(multiple_day.start_date).format('Do MMMM YYYY, HH.mm') }</span>
                )
            })
        }
        return this._getFormattedDate(event.start_date);
    }

    _getFormattedDate(start_date) {
        return <span>{ moment(start_date).format('Do MMMM YYYY, HH.mm') }</span>
    }

    _attendeeUpdated() {

        this.props.hideEditAttendeeOverlay();
        this.props.refreshEvents();
    }

    _filterEvents(e) {

        this.props.filterEventsByDate(e.target.value || null);
        this.props.refreshEvents();
    }

    _showEventOnWebsite(eventId, e) {

        return new Promise((resolve, reject) => {
            const success = response => {

                resolve(response.data);

                notifier.addNotification({
                    message: 'Your Event has been set to show on the Website.',
                    level: 'success'
                });

                this.props.refreshEvents();
                this.props.refreshWebsiteAvailablePositionsForEvents();
            };

            const failure = errors => {

                if (errors.website_display_position) {
                    notifier.addNotification({
                        message: 'You must select a display position',
                        level: 'error'
                    });
                }

                reject(errors);
            };

            eventRepo.updateWebsiteDisplayPosition({
                id: eventId,
                website_display_position: e.target.value
            }).then(success, failure);
        });
    }

    render() {

        return (

            <article>

                <Button onClick={ this.props.showNewEventOverlay }
                        styleName="new-event-button">

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New Event</span>

                </Button>

                <Overlay isOpen={ this.props.isDeleteEventOverlayOpen }
                         closeOverlay={ this.props.hideDeleteEventOverlay }
                         title="Delete Event"
                         size="small">

                    { this._getDeleteEventOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isDeleteAttendeeOverlayOpen }
                         closeOverlay={ this.props.hideDeleteAttendeeOverlay }
                         title="Delete Attendee"
                         size="small">

                    { this._getDeleteAttendeeOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isNewEventOverlayOpen }
                         closeOverlay={ this.props.hideNewEventOverlay }
                         title="New Event"
                         size="medium">

                    <EventForm submitSuccess={ this.props.eventCreated } />

                </Overlay>

                <Overlay isOpen={ this.props.isEditEventOverlayOpen }
                         closeOverlay={ this.props.hideEditEventOverlay }
                         title="Edit Event"
                         size="medium">

                    <EventForm submitSuccess={ this.props.eventUpdated } />

                </Overlay>

                <Overlay isOpen={ this.props.isEditAttendeeOverlayOpen }
                         closeOverlay={ this.props.hideEditAttendeeOverlay }
                         title="Edit Attendee"
                         size="medium">

                    <AttendeeForm mode="edit"
                                  attendee={ this.props.attendeeToEdit }
                                  submitted={ this._attendeeUpdated.bind(this) } />

                </Overlay>

                <Overlay isOpen={ this.props.isAddAttendeeOverlayOpen }
                         closeOverlay={ this.props.hideAddAttendeeOverlay }
                         title="Add Attendee"
                         size="medium">

                    <AttendeeForm mode="add"
                                  eventId={ this.props.addingAttendeeToEventId }
                                  submitted={ this.props.attendeeAdded } />

                </Overlay>

                <InputGroup styleName="filter-bar">

                    <Label>Show events from</Label>

                    <SelectBox onChange={ this._filterEvents.bind(this) }
                               className={ style['module-filter'] }>

                        <option value={ moment().format('YYYY-MM-DD 00:00 Z').toString() }>
                            Today onwards
                        </option>

                        <option value={ moment().subtract(moment.duration(3, 'months')).format() }>
                            Last 3 months onwards
                        </option>

                        <option value={ moment().subtract(moment.duration(6, 'months')).format() }>
                            Last 6 months onwards
                        </option>

                        <option value={ moment().subtract(moment.duration(12, 'months')).format() }>
                            Last 12 months onwards
                        </option>

                        <option value={ '' }>
                            Any time
                        </option>

                    </SelectBox>

                </InputGroup>

                <section styleName="events-list">

                    {
                        this.props.events.map((event, index) => {

                            const eventSheetUrl = `/api/v1/events/${ event.id }/sheet?token=${ authenticator.getSessionToken() }`;

                            return (
                                <article key={ index } styleName="event">

                                    <div styleName="event-header">
                                        <span styleName="event-reference">{ event.reference_code }</span>
                                        <h2 styleName="course-name">{ event.course.name }</h2>
                                        <h3 styleName="module-name">{ event.course.module.name }</h3>
                                    </div>

                                    <div styleName="event-actions-panel">

                                        <div className={style['event-action']}>
                                            <WebsitePositionDropDown
                                                selectedPosition={event.website_display_position}
                                                websiteDisplayPositionsAvailable={this.props.websiteDisplayPositionsAvailable}
                                                eventId={event.id}
                                                showEventOnWebsite={this._showEventOnWebsite.bind(this)}
                                                />
                                        </div>

                                        <a styleName="event-action"
                                           onClick={ this.props.showEditEventOverlay.bind(this, event) }>

                                            Edit
                                        </a>

                                        <a styleName="event-action"
                                           onClick={ this.props.showDeleteEventOverlay.bind(this, event) }>

                                            Delete
                                        </a>
                                    </div>

                                    <div styleName="event-detail-container">

                                        <div styleName="event-detail">
                                            <FontIcon textPosition="right" iconName="clock-o" className="multiple_date-icon"/>
                                            { this._getEventDates(event) }
                                        </div>

                                        <div styleName="event-detail">
                                            <FontIcon textPosition="right" iconName="map-marker" />
                                            {event.course.type !== "webinar" ? (
                                                <span>{ this._getEventAddress(event) }</span>
                                            ) : (
                                                <span>Webinar</span>
                                            )}

                                        </div>

                                        <div styleName="event-detail">
                                            <FontIcon textPosition="right" iconName="users" />
                                            <span>{ event.attendees.length }/{ event.max_delegates } places booked</span>
                                        </div>

                                    </div>

                                    <a styleName="event-sheet-link" href={ eventSheetUrl } target="_blank">
                                        <FontIcon textPosition="right" iconName="download" />
                                        <span>Event sheet</span>
                                    </a>

                                    { this._getAttendeesList(event) }

                                    { this._getAttendeesDropdownLink(event.id) }

                                </article>
                            );
                        })
                    }

                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.adminEventList;
}

function mapDispatchToProps(dispatch) {

    return {
        refreshWebsiteAvailablePositionsForEvents() {

          dispatch(eventList.refreshWebsiteDisplayPositionsAvailable());
        },
        toggleAttendingMultipleDays(attendee) {

            dispatch(eventList.toggleAttendingMultipleDays(attendee));
        },
        sortAttendees(eventId, attribute, direction) {

            dispatch(eventList.sortAttendees(eventId, attribute, direction));
        },
        filterEventsByDate(fromDate) {

            dispatch(eventList.filterEventsByDate(fromDate));
        },
        attendeesUpdated(eventId) {

            dispatch(eventList.resetSelectAllAttendees(eventId));
            dispatch(eventList.refreshEvents());
        },
        toggleSelectAllAttendees(eventId) {

            dispatch(eventList.toggleSelectAllAttendees(eventId));
        },
        attendeeSelectionChanged(eventId, attendeeId, isSelected) {

            dispatch(eventList.attendeeSelectionChanged(eventId, attendeeId, isSelected));
        },
        attendeeAdded() {

            dispatch(eventList.hideAddAttendeeOverlay());
            dispatch(eventList.refreshEvents());
        },
        showAddAttendeeOverlay(eventId) {

            dispatch(eventList.showAddAttendeeOverlay(eventId));
        },
        hideAddAttendeeOverlay() {

            dispatch(eventList.hideAddAttendeeOverlay());
        },
        deleteAttendee(attendeeId) {

            dispatch(eventList.deleteAttendee(attendeeId));
        },
        hideDeleteAttendeeOverlay() {

            dispatch(eventList.hideDeleteAttendeeOverlay());
        },
        hideEditAttendeeOverlay() {

            dispatch(eventList.hideEditAttendeeOverlay());
        },
        showEditAttendeeOverlay(attendee) {

            dispatch(eventList.showEditAttendeeOverlay(attendee));
        },
        showDeleteAttendeeOverlay(attendee) {

            dispatch(eventList.showDeleteAttendeeOverlay(attendee));
        },
        showEditEventOverlay: (event) => {

            dispatch(eventList.showEditEventOverlay(event));
        },
        hideEditEventOverlay: () => {

            dispatch(eventList.hideEditEventOverlay());
        },
        eventCreated: () => {

            dispatch(eventList.hideNewEventOverlay());
            dispatch(eventList.refreshEvents());
        },
        eventUpdated: () => {

            dispatch(eventList.hideEditEventOverlay());
            dispatch(eventList.refreshEvents());
        },
        deleteEvent: (eventId) => {

            dispatch(eventList.deleteEvent(eventId));
        },
        showDeleteEventOverlay: (event) => {

            dispatch(eventList.showDeleteEventOverlay(event));
        },
        hideDeleteEventOverlay: () => {

            dispatch(eventList.hideDeleteEventOverlay());
        },
        refreshEventOptions: () => {

            dispatch(eventList.refreshEventOptions());
        },
        showAttendees: (eventId) => {

            dispatch(eventList.showAttendees(eventId));
        },
        hideAttendees: (eventId) => {

            dispatch(eventList.hideAttendees(eventId));
        },
        refreshEvents: () => {

            dispatch(eventList.refreshEvents());
        },
        showNewEventOverlay: () => {

            dispatch(eventList.showNewEventOverlay());
        },
        hideNewEventOverlay: () => {

            dispatch(eventList.hideNewEventOverlay());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(EventList, style));


// WEBPACK FOOTER //
// ./components/EventList/index.js